import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class RequestTrackerService {
    
    private requestCount: number = 0;
    public requestCount$ = new BehaviorSubject<number>(0);

    public startRequest(): void {
        this.requestCount++;
        this.requestCount$.next(this.requestCount);
    }

    public endRequest(): void {
        this.requestCount--;
        this.requestCount$.next(this.requestCount);
    }

    public isLoading(): boolean {
        return this.requestCount > 0;
    }
}
